import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { Route, Routes } from "react-router";
import ReactDOM from "react-dom/client";
import "./style.scss";
import Application from "./containers/Application";
import * as serviceWorker from "./serviceWorker";
import Root from "Root";
import { PageNotFound } from "component/page";
import withRouterCompat from "utils/withRouterCompat";
import "./i18n";

const WrappedApplication = withRouterCompat(Application, "/:locale/:sessionId/*");

ReactDOM.createRoot(document.getElementById("root")).render(
  <Root>
    <Routes>
      <Route path="/:locale/:sessionId/*" element={<WrappedApplication />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  </Root>
);

serviceWorker.unregister();
/* serviceWorker.register({
  onUpdate: (registration, initialUpdate) => {
    // dispatch and event whne there is a  pending update
    const updateEvent = new CustomEvent('newContentAvailable', {
      detail: {
        registration: registration,
        initialUpdate: initialUpdate
      }
    });
    window.dispatchEvent(updateEvent);
  },
  onActivated: () => {
    const updateEvent = new CustomEvent('serviceWorkerActivated');
    window.dispatchEvent(updateEvent);
  }
}) */
